<template>
    <div class="bg-white p-5 shadow-md rounded-xl h-full">
        <h2 class="text-lg font-semibold text-gray-700 mb-3 flex items-center">
            <span class="mr-2">📊</span>
            <span>Partners by Status</span>
        </h2>
        <div v-if="hasData" class="chart-container">
            <apexchart type="bar" height="260" :options="chartOptions" :series="chartSeries" @dataPointSelection="onBarSelect" />
        </div>
        <div v-else class="chart-empty">
            <span class="chart-empty-icon">📊</span>
            <p class="chart-empty-text">No data available</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "PartnersByStatusChart",
    props: {
        data: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    computed: {
        hasData() {
            return this.data && this.data.length > 0;
        },
        chartOptions() {
            return {
                chart: {
                    type: "bar",
                    toolbar: { show: false },
                },
                xaxis: {
                    categories: this.data.map(function (item) {
                        return item.status;
                    }),
                    title: {
                        text: "Status",
                        style: {
                            fontSize: "12px",
                            fontWeight: "bold",
                        },
                    },
                    labels: {
                        maxWidth: 120,
                        style: {
                            fontSize: "11px",
                        },
                    },
                },
                yaxis: {
                    title: {
                        text: "Number of Partners",
                        style: {
                            fontSize: "12px",
                            fontWeight: "bold",
                        },
                    },
                    min: 0,
                    forceNiceScale: true,
                },
                colors: this.getPowerBIColors(),
                plotOptions: {
                    bar: {
                        borderRadius: 8,
                        borderRadiusApplication: "end",
                        columnWidth: "55%",
                        distributed: true,
                        dataLabels: {
                            position: "center",
                        },
                    },
                },
                dataLabels: {
                    enabled: true,
                    offsetY: 0,
                    style: {
                        fontSize: "13px",
                        fontWeight: 700,
                        colors: ["#ffffff"],
                    },
                    formatter: function (val) {
                        return val;
                    },
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " partner" + (val === 1 ? "" : "s");
                        },
                    },
                },
                legend: {
                    show: false
                },
                grid: {
                    borderColor: "#e2e8f0",
                    strokeDashArray: 4,
                },
            };
        },
        chartSeries() {
            return [{
                name: "Partners",
                data: this.data.map(function (item) {
                    return item.count;
                }),
            }];
        }
    },
    methods: {
        onBarSelect: function (event, chartContext, config) {
            var index = config && typeof config.dataPointIndex === "number" ? config.dataPointIndex : -1;
            var selectedItem = this.data && index >= 0 ? this.data[index] : null;
            if (selectedItem && selectedItem.status) {
                this.onStatusBarClick(selectedItem.status);
            }
        },
        onStatusBarClick(status) {
            this.$emit("status-clicked", status);
        },
        getPowerBIColors() {
            return [
                "#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd",
                "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf",
                "#aec7e8", "#ffbb78", "#98df8a", "#ff9896", "#c5b0d5"
            ];
        }
    }
};
</script>

<style scoped>
.chart-container {
    cursor: pointer;
}
.chart-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 260px;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px dashed #cbd5e1;
}
.chart-empty-icon {
    font-size: 2.5rem;
    margin-bottom: 0.5rem;
    opacity: 0.6;
}
.chart-empty-text {
    font-size: 0.9375rem;
    color: #64748b;
}
</style>
